/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FillInvoiceQRDto
 */
export interface FillInvoiceQRDto {
    /**
     * 
     * @type {string}
     * @memberof FillInvoiceQRDto
     */
    qrBitmap?: string;
}

/**
 * Check if a given object implements the FillInvoiceQRDto interface.
 */
export function instanceOfFillInvoiceQRDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FillInvoiceQRDtoFromJSON(json: any): FillInvoiceQRDto {
    return FillInvoiceQRDtoFromJSONTyped(json, false);
}

export function FillInvoiceQRDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FillInvoiceQRDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'qrBitmap': !exists(json, 'qrBitmap') ? undefined : json['qrBitmap'],
    };
}

export function FillInvoiceQRDtoToJSON(value?: FillInvoiceQRDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'qrBitmap': value.qrBitmap,
    };
}

